// stocai_frontend/src/components/HomePage/components/widgets/Module7/Steps/FuturePromotionStep.jsx

import React from "react";
import bgFutureImg from "../../../../../../assets/bg_future.png";
import futurePersonImg from "../../../../../../assets/future_person.png";
import spotlightImg from "../../../../../../assets/spotlight.png";
import ellipseImg from "../../../../../../assets/ellipse.png";

const FuturePromotionStep = ({
  monthsAhead = 12,
  futureTitle = "",
  textareaValue,
  setTextareaValue,
  isSaving,
  onNextStep,
}) => {
  const handleChange = (e) => {
    if (setTextareaValue) setTextareaValue(e.target.value);
  };

  const handleContinue = () => {
    if (onNextStep) onNextStep();
  };

  // friendly fallbacks while DB values load
  const displayMonths = monthsAhead ?? 12;
  const displayTitle = futureTitle || "Senior Manager";

  return (
    <div className="w-full max-h-[80vh] bg-white flex flex-col items-center overflow-y-auto scrollbar-hide">
      {/* Top text block */}
      <div className="mb-6 flex flex-col items-center text-center px-4">
        <h1
          className="text-[32px] font-[500] leading-[135%] text-[#000000] mb-2 font-[Gotham]"
        >
          You&apos;re already promoted!
        </h1>
        <p
          className="text-[19px] font-[400] leading-[165%] text-[#323232] max-w-[640px] font-[Gotham]"
        >
          Imagine it&apos;s {displayMonths} months from today. You&apos;ve been promoted
          to
        </p>
        <div className="mt-1 text-[26px] font-[500] leading-[135%] text-[#54B0AF] font-[Gotham]">
          {displayTitle}
        </div>
      </div>

      {/* Illustration area */}
      <div className="w-full flex justify-center mb-6">
        <div className="relative w-[760px] h-[520px] -mt-10">
          {/* Background boardroom */}
          <img
            src={bgFutureImg}
            alt="Future boardroom"
            className="absolute inset-0 m-auto w-[758px] h-[874px] object-contain pointer-events-none select-none"
            draggable={false}
          />

          {/* Spotlight */}
          <img
            src={spotlightImg}
            alt="Spotlight"
            className="absolute w-[270px] h-[270px] left-[49.8%] top-[64px] -translate-x-1/2 object-contain pointer-events-none select-none"
            draggable={false}
          />

          {/* Ellipse */}
          <img
            src={ellipseImg}
            alt="Spotlight ellipse"
            className="absolute w-[142px] h-[38px] left-[49.8%] top-[48px] -translate-x-1/2 object-contain pointer-events-none select-none"
            draggable={false}
          />

          {/* Person */}
          <img
            src={futurePersonImg}
            alt="Future you"
            className="absolute w-[280px] h-[420px] left-1/2 top-[180px] -translate-x-1/2 object-contain pointer-events-none select-none"
            draggable={false}
          />
        </div>
      </div>

      {/* Prompt + textarea */}
      <div className="w-full flex flex-col items-center mt-16 px-4 mb-8">
        <p className="text-[19px] font-[400] leading-[165%] text-[#323232] mb-4 font-[Gotham]">
            Close your eyes. What do you see?
        </p>

        <div className="w-full max-w-[765px] min-h-[187px] border border-[#ADADAD] rounded-[5px] bg-white">
            <textarea
            value={textareaValue || ""}
            onChange={handleChange}
            placeholder={
                "Describe what you see:\n • What are you doing?\n • Who do you see around you?\n • What do you hear and feel?"
            }
            className="
                w-full min-h-[187px] outline-none p-6
                text-[18px] leading-[165%] text-[#54B0AF]
                font-medium
                font-[Gotham]
                placeholder:text-[#9B9B9B]
                placeholder:text-[18px]
                placeholder:leading-[165%]
                placeholder:font-[400]
                resize-none
                overflow-hidden
            "
            />
        </div>

        {isSaving && (
            <div className="text-[12px] text-[#9F9E9E] font-[Gotham] mt-2">
              Saving...
            </div>
        )}
        </div>


      {/* Bottom button */}
      <div className="mb-10">
            <button
                type="button"
                onClick={handleContinue}
                className="
                flex items-center justify-between
                bg-black text-white text-[17px]
                font-gotham font-medium
                w-[255px] h-[56px]
                rounded-[16.2px]
                pt-[17.82px] pb-[17.82px] px-[16.2px]
                "
            >
                Step into the Future
                <span className="ml-3 flex items-center justify-center w-[16px] h-[16px] rounded-full bg-white text-black">
                <svg width={12} height={12} viewBox="0 0 20 20" fill="none" aria-hidden>
                    <path
                    d="M8 5l4 5-4 5"
                    stroke="#151A1F"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    />
                </svg>
                </span>
            </button>
        </div>
    </div>
  );
};

export default FuturePromotionStep;
